module.exports = __webpack_public_path__ + "img/bg-dark.3ba294e3.webp";